import { setCookie } from 'bits/cookie'
import jstz from 'jstz'

function setTimezoneCookie(): void {
  const timeZone = jstz.determine().name()
  setCookie('ww_tz', timeZone)
}

export { setTimezoneCookie }
